import { IconChevronRight } from '@tabler/icons-react-native'
import { type FC, type ReactNode } from 'react'

import { HStack, Icon, Pressable, Text, VStack, type PressableProps } from '@/components'

export interface PressableListItemProps extends Omit<PressableProps, 'children'> {
  left?: ReactNode
  right?: ReactNode
  subtitle?: string | null | undefined
  title: string | null | undefined
}

export const PressableListItem: FC<PressableListItemProps> = ({ left, onPress, subtitle, title, right, ...props }) => (
  <Pressable
    accessibilityRole='button'
    onPress={onPress}
    {...props}
  >
    <HStack className='min-h-10 items-center justify-between gap-4'>
      {left}
      <VStack className='flex-1 justify-center'>
        {title ? (
          <Text
            className='font-poppinsSemiBold text-white'
            numberOfLines={1}
          >
            {title}
          </Text>
        ) : null}
        {subtitle ? (
          <Text
            className='text-xs text-white'
            numberOfLines={1}
          >
            {subtitle}
          </Text>
        ) : null}
      </VStack>
      <HStack className='items-center gap-2'>
        {right}
        <Icon
          as={IconChevronRight}
          size='xl'
        />
      </HStack>
    </HStack>
  </Pressable>
)
